export interface SendPinCodeResponse {

}

export interface SendPinCodeRequest {
    authorizedRepresentativeId: string;
}

export enum AuthenticatePinCodeResult {
    Success,
    Failed,
    RequestFailed
}

export interface AuthenticatePinCodeResponse {
    expiryDate: string;
    token: string;
}

export interface AuthenticatePinCodeRequest {
    authorizedRepresentativeId: string;
    pinCode: string;
}



// WEBPACK FOOTER //
// ./src/dtos/pin-code.ts